var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStartSparks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #29ade6;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.7,16.1l-6.4-2.4-2.4-6.5c-.4-1-1.5-1.6-2.6-1.2-.5.2-1,.6-1.2,1.2l-2.4,6.5-6.5,2.4c-1,.4-1.6,1.5-1.2,2.6.2.5.6,1,1.2,1.2l6.5,2.4,2.4,6.5c.4,1,1.5,1.6,2.6,1.2.5-.2,1-.6,1.2-1.2l2.4-6.5,6.5-2.4c1-.4,1.6-1.5,1.2-2.6-.2-.5-.6-1-1.2-1.2h0ZM17.1,20.5c-.3.1-.5.3-.6.6l-2.5,6.9-2.5-6.9c-.1-.3-.3-.5-.6-.6l-6.9-2.5,6.9-2.5c.3-.1.5-.3.6-.6l2.5-6.9,2.5,6.9c.1.3.3.5.6.6l6.9,2.5-6.9,2.5ZM18,5c0-.6.4-1,1-1h2v-2c0-.6.4-1,1-1s1,.4,1,1v2h2c.6,0,1,.4,1,1s-.4,1-1,1h-2v2c0,.6-.4,1-1,1s-1-.4-1-1v-2h-2c-.6,0-1-.4-1-1ZM31,11c0,.6-.4,1-1,1h-1v1c0,.6-.4,1-1,1s-1-.4-1-1v-1h-1c-.6,0-1-.4-1-1s.4-1,1-1h1v-1c0-.6.4-1,1-1s1,.4,1,1v1h1c.6,0,1,.4,1,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStartSparks);
export default __webpack_public_path__ + "static/media/icon-start-sparks.d803d8ffa3d2fc0e71601d28c40cbb6a.svg";
export { ForwardRef as ReactComponent };